import { Component } from "react";
import { Link } from "react-router-dom";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[coachly] React error boundary caught:", error, info);
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        className="min-h-screen flex items-center justify-center p-6"
        style={{ background: "#f9f8f6" }}
        data-testid="error-boundary"
      >
        <div className="max-w-md w-full rounded-2xl border border-[#e5e2da] bg-white p-8 text-center">
          <div className="text-xs uppercase tracking-[0.2em] text-[#8c9b86]">Something went wrong</div>
          <h1 className="font-serif-display text-3xl mt-3 leading-tight">
            The page hit a snag.
          </h1>
          <p className="text-[#5c5c5c] mt-3 text-sm">
            Try refreshing the page. If it keeps happening, head back home and start over.
          </p>
          <pre className="mt-4 text-[10px] text-left text-[#8b8b8b] bg-[#efece5] rounded p-2 overflow-auto max-h-32">
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <div className="mt-5 flex gap-3 justify-center">
            <button
              onClick={() => window.location.reload()}
              data-testid="error-refresh-btn"
              className="rounded-full bg-[#163325] hover:bg-[#0e2419] text-[#f9f8f6] px-5 py-2 text-sm"
            >
              Refresh page
            </button>
            <Link
              to="/"
              onClick={this.reset}
              data-testid="error-home-link"
              className="rounded-full border border-[#e5e2da] px-5 py-2 text-sm text-[#3c3c3c] hover:bg-[#efece5]"
            >
              Back home
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
